import { PasswordResetRequest } from "../../../@types/Auth";
import { api } from "../../api";

export default async function passwordReset(dto: PasswordResetRequest) {
  try {
    const { data } = await api.post("/auth/password/reset", dto);

    return data;
  } catch (err) {
    console.log(err);

    return null;
  }
}
